import { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoodIcon from '@mui/icons-material/Mood';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import PlayerGeneralStatusCard from './player-general-status-card';

const PlayerGeneralStatus = ({ players, title, status, displayConvocatoria, defaultOpen = true }) => {
    const [open, setOpen] = useState(defaultOpen);
    const theme = useTheme();

    const getPlayerList = () => {
        if (players?.length > 0) {
            return (
                <Box>
                    {players?.map((p, index) => (
                        <PlayerGeneralStatusCard
                            noticia={p}
                            status={status}
                            players={players}
                            displayConvocatoria={displayConvocatoria}
                            key={index}
                        />
                    ))}
                </Box>
            );
        }

        return (
            <Box display={'flex'} alignItems={'center'} pl={1} className="player-information-container__body">
                <MoodIcon
                    sx={{ fontSize: '14px', color: theme.palette.secondary.main, marginRight: '4px' }}
                />
                <Typography fontSize={'14px'} color={theme.palette.text.primary}>
                    No hay jugadores en esta categoría
                </Typography>
            </Box>
        );
    };

    return (
        <Box border={`1px solid ${theme.palette.border.main}`} borderRadius={1} mb={1}>
            <Box
                onClick={() => setOpen(!open)}
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                pl={1}
                height={25}
                bgcolor="background.darkCard"
                borderBottom={`1px solid ${theme.palette.border.main}`}
            >
                <Typography fontWeight={500} fontSize={14}>
                    {title}
                </Typography>
                <IconButton>
                    {open ? <ExpandMoreIcon fontSize="small" /> : <ExpandLessIcon fontSize="small" />}
                </IconButton>
            </Box>

            <Collapse in={open}>
                <Box py={0.5}>{getPlayerList()}</Box>
            </Collapse>
        </Box>
    );
};

export default PlayerGeneralStatus;
